class SharingStatus {
  static getTranslationByStatus(status) {
    return SharingStatus.states.get(status + "");
  }

  static getStatus() {
    return SharingStatus.statesArray;
  }
}

SharingStatus.statusObject = {
  0: "SharingStatus.NOT_SHARED",
  1: "SharingStatus.SHARING_IN_PROGRESS",
  2: "SharingStatus.SHARED",
  3: "SharingStatus.STOP_SHARING_IN_PROGRESS"
};

SharingStatus.states = new Map();
SharingStatus.statesArray = [];
for (const i in SharingStatus.statusObject) {
  SharingStatus.statesArray.push({
    code: i,
    translation: SharingStatus.statusObject[i]
  });
  SharingStatus.states.set(i + "", SharingStatus.statusObject[i]);
}

export default SharingStatus;
